import React, { Component } from "react"
import { Link } from "gatsby"

import Layout from "../components/layout"
import SEO from "../components/seo"

import TopContainer from "../components/TopContainer"
import Footer from "../components/Footer"
import Blocks from "../components/Blocks"
import {
  Group,
  Col,
  Section,
  CtaButton,
  VideoEmbed,
} from "../components/common"

import img from "../images/home-top-bg.jpg"
import img2 from "../images/photo1.jpg"

import imgBackground from "../images/background.png"
import imgTestimonials from "../images/testimonials.png"
import imgTeam from "../images/team.png"
import imgFund from "../images/fund.png"
import imgSolution from "../images/s-factor/solution.png"

import circles from "../images/s-factor/circles.png"
import mspi from "../images/s-factor/mspi.jpg"
import mspi2 from "../images/s-factor/mspi2.png"
import boxes from "../images/s-factor/boxes.jpg"
import boxes2 from "../images/s-factor/boxes2.png"
import features from "../images/s-factor/features.png"

import imgMoneyPlant from "../images/moneyplant.jpg"

class SFactorPage extends Component {
  state = {
    blockData: [
      {
        title: "11,000+",
        subtitle: "Companies",
        color: "#F05E2A",
      },
      {
        title: "74",
        subtitle: "Social Impact Themes",
        color: "#F37043",
      },
      {
        title: "45",
        subtitle: "Frameworks",
        color: "#F37F58",
      },
      {
        title: "300+",
        subtitle: "Social specific indicators & thousands of metrics",
        color: "#F6906E",
      },
    ],
  }

  render() {
    return (
      <>
        <Layout>
          <SEO title="S Factor" keywords={[]} />
          <div className="page page-s-factor">
            <TopContainer
              titleLines={["We put the S in ESG."]}
              backgroundImage={img}
              body="Sustainable, Responsible and Impact investing (SRI) - an investment discipline which considers environmental, social and corporate governance (ESG) criteria to generate long-term competitive financial returns."
              ctaText="Learn More"
              ctaLinkTo={"/about"}
            />
            <Section>
              <Group>
                <Col size="third">
                  <div className="headingAccent" />

                  <h3>S Factor</h3>
                </Col>
              </Group>
              <Group>
                <Col size="half">
                  <p>
                    The S Factors are the Social Factors, most of which are
                    missing or are too “high-level” for current ESG
                    considerations. The social impact factors are our area of
                    subject-expertise, a discipline where we have been working
                    boots-on-the-ground for over two decades specifically
                    measuring social impacts.
                  </p>
                  <p>
                    The S Factor Co., is a MacCormick Inc. company, established
                    in 2009. MacCormick created the World’s
                  </p>
                </Col>
                <Col size="half">
                  <p>
                    First, Social Performance Index in 2010. Known as the MSPI
                    <sup>TM</sup>, it measures and benchmarks companies’ social
                    impact and risk performance in accordance with dozens of
                    frameworks and hundreds of indicators.
                  </p>
                </Col>
              </Group>
            </Section>
            <Section>
              <Group>
                <Col size="third">
                  <div className="headingAccent" />

                  <h3>
                    The S Factor<sup>TM</sup> Solution
                  </h3>
                </Col>
                <Col size="two-thirds">
                  <p>
                    The nucleus of the S Factor model measures individual
                    companies’ socio-economic, socio- cultural and
                    socio-political impact on people, starting with its
                    employees in every location of operation, and incorporating
                    the communities where it does business. The S Factor
                    assesses metrics in these 6 core areas through the lens of
                    the people, and correlates deep-dive analysis on ROI &amp;
                    SROI in relation to a variety of impacts in these areas.
                  </p>
                  <hr />
                  <img src={imgSolution} width={"100%"} />
                </Col>
              </Group>
            </Section>

            <Section>
              <h4 className="bigger">
                Are companies doing more than they are simply required to do,
                because it’s the right thing to do?
              </h4>
            </Section>

            <Section>
              <Group>
                <Col size="third">
                  <div className="headingAccent" />

                  <h3>Methodology, Compliance &amp; Materiality</h3>
                </Col>
                <Col size="two-thirds">
                  <p>
                    Each of our 300+ indicators may relate to several
                    international frameworks and standards, of which there are
                    thousands. The S Factor has standardized and simplified the
                    metrics across multiple frameworks, making it faster and
                    easier to access compliance or risk. For example:
                  </p>
                  <p>
                    Determining whether employees are “working excessive hours”
                    may actually relate to several frameworks from non-related
                    entities, such as: International Labour Standard (ILO);
                    International Finance Corporation, Performance Standards
                    (IFC, PS); United Nations Declaration on Human Rights
                    (UNDHR)...and so on. There are many!
                  </p>
                  <p>
                    It is valuable to know how many frameworks you qualify for,
                    as you may need to comply to several in various
                    jurisdictions.
                  </p>
                  <p>
                    It is not enough for a company to publish a policy on each
                    theme or topic. In order to truly measure impact - to
                    qualify and to quantify it - they must demonstrate
                    implementation with material evidence as well as ongoing
                    monitoring and evaluation of performance. Qualifying
                    statements must have third-party validation.
                  </p>
                  <p>
                    <h5>Our database covers</h5>
                  </p>
                  <ul>
                    <li>11,000+ companies,</li>
                    <li>74 social impact themes,</li>
                    <li>45 frameworks,</li>
                    <li>
                      300+ social specific indicators and thousands of metrics.
                    </li>
                  </ul>
                </Col>
              </Group>
            </Section>

            <Section>
              <h4 className="bigger">
                Do companies understand how they impact people, and does it
                matter to them?
              </h4>
            </Section>

            <Section>
              <Group>
                <Col size="third">
                  <h3>Results</h3>
                  <div className="headingAccent" />

                  <img src={circles} width="70%" />
                </Col>
                <Col size="two-thirds">
                  <p>
                    <h5>Score</h5>
                  </p>
                  <p>
                    The S Factor<sup>TM</sup> score (“the score”) qualifies
                    evidence of material information from multiple validated
                    sources on a company’s social performance, data
                    availability, and industry relevance. There are 4 possible
                    scores associated with each of the 300+ indicators, each
                    benchmarking hundreds of themes and indicators in accordance
                    with dozens of frameworks.
                  </p>
                  <p>
                    The objective is to determine whether individual companies
                    understand what social impact is, how to measure it, how to
                    implement measures to mitigate their risks associated with
                    it, and how to track and report on it – whether its required
                    regulatory compliance or best-practice.
                  </p>
                  <p />
                </Col>
              </Group>
            </Section>

            <Section>
              <Group>
                <Col size="third">
                  <div className="headingAccent" />

                  <img src={mspi2} width="70%" />
                </Col>
                <Col size="two-thirds">
                  <p>
                    <h5>Index</h5>
                    <p>
                      The MSPI<sup>TM</sup> considers the S FactorTM score plus
                      controversies and public sentiment in its ranking of
                      companies on social impact, by country, by industry, by
                      theme and by indicator in correlation to financial
                      performance. Companies in this ranking demonstrate a high
                      S FactorTM score, positive public sentiment and superior
                      financial returns. This deep- dive analysis allows you to
                      quickly separate the best from the rest, ensuring that the
                      companies doing well here are a class-above.
                    </p>
                  </p>
                </Col>
              </Group>
            </Section>

            <Section>
              <Group>
                <Col size="third">
                  <div className="headingAccent" />

                  <img src={boxes2} width="70%" />
                </Col>
                <Col size="two-thirds">
                  <p>
                    <h5>Ratings</h5>
                  </p>
                  <p>
                    While the MSPI<sup>TM</sup> identifies the top performing
                    companies, the information created by the S Factor modelling
                    can also inform risk ratings as it relates to social issues,
                    the probabilities of disruption, and the level of
                    preparedness to manage uncertainties. The S FactorTM scores
                    provide a well-rounded and comprehensive measure of a
                    company’s social performance.
                  </p>
                  <p className="legal">
                    *Controversies: Include any scandals, disasters, litigation,
                    disputes, or protest against the company, its operations, or
                    investments. Controversies and sentiment are benchmarked on
                    any or all of the S Factor score themes and weighted
                    accordingly, resulting in an aggregated percentile.
                  </p>

                  <p className="legal">
                    ** Sentiment: scans of 50,000 news and social media sites in
                    14 languages for both positive and negative sentiment on key
                    themes; results are then blended with the controversy score
                    for an aggregated percentile.
                  </p>
                </Col>
              </Group>
            </Section>

            <Section>
              <h4 className="bigger">
                The S Factor’s information tools easily identify companies with
                strong social performance or exposure to social risks, allowing
                you to make well-informed, data- driven decisions.
              </h4>
            </Section>

            <Section>
              <Group>
                <Col size="half">
                  <div className="headingAccent" />

                  <h3>Product features</h3>

                  <img src={features} width={"90%"} />
                </Col>
                <Col size="half">
                  <p>
                    <h5>ESG</h5>
                  </p>

                  <ul>
                    <li>Ensure compliance with your policies</li>
                    <li>
                      Monitor and receive alerts when there is possible breach
                      of your social impact Code of Conduct
                    </li>
                    <li>
                      Understand the social impacts and risks associated with
                      each sector
                    </li>
                  </ul>

                  <p>
                    <h5>Impact</h5>
                  </p>
                  <ul>
                    <li>
                      Dispel impact-washing with the true-measure and true-cost
                      of social impact
                    </li>
                    <li>
                      Research and understand the social impact and risk
                      challenges in the countries and sectors in which you
                      invest or do business
                    </li>
                  </ul>

                  <p>
                    <h5>Reporting</h5>
                  </p>
                  <ul>
                    <li>Automatic compliance reporting</li>
                    <li>
                      Research social impact issues and trends to guide policy
                      development and management strategy
                    </li>
                    <li>
                      Track and benchmark your social impact and risk exposure
                      against that of your peers
                    </li>
                  </ul>
                </Col>
              </Group>
            </Section>
          </div>
        </Layout>
      </>
    )
  }
}

export default SFactorPage
